/**
 * ADMIN Redux store - extend shared redux store
 */
import { createAppStore, thunkUserIp } from "@smfa/utils/src/store";
import logger from "redux-logger";

// Shared utilities store:
export const { store, persistor } = createAppStore({
  reducers: {},
  middleware: [logger],
  persistWhitelist: ["auth", "user"],
  // Initialize app after store creation
  afterCreate: (store) => {
    store.dispatch(thunkUserIp()); // Dispatch IP fetch
    // Make store available for non-component code
    window.store = store;
  },
});
